import styled from 'styled-components';

export const StyledSelect = styled('div')`
  border: 1px solid #999;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
  background-color: #ffffff;

  display: flex;

  height: 48px;

  overflow: hidden;

  position: relative;
`;

export const Flag = styled('div')`
  height: 100%;
  width: 57px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-right: 1px solid #999;

  & img {
    height: 29px;
  }
`;

export const StyledNationalitySelect = styled('select')`
  width: 100%;
  border: 0;
  background-color: #ffffff;
  padding: 9px;
  flex-grow: 1;

  color: #595959;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #999;
  flex-shrink: 0;
`;

export const StyledNationalitySelectLabel = styled('label')`
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 10px;
  color: #4d4d4d;
`;

export const Wrapper = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`;
